var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    stroke: "#999999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75008 10.0831C8.75008 10.8124 9.03981 11.5119 9.55554 12.0276C10.0713 12.5433 10.7707 12.8331 11.5001 12.8331C12.2294 12.8331 12.9289 12.5433 13.4446 12.0276C13.9603 11.5119 14.2501 10.8124 14.2501 10.0831C14.2501 9.35372 13.9603 8.65425 13.4446 8.13852C12.9289 7.6228 12.2294 7.33307 11.5001 7.33307C10.7707 7.33307 10.0713 7.6228 9.55554 8.13852C9.03981 8.65425 8.75008 9.35372 8.75008 10.0831Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6857 15.2686L12.7963 19.1581C12.4525 19.5015 11.9865 19.6944 11.5005 19.6944C11.0146 19.6944 10.5486 19.5015 10.2048 19.1581L6.3145 15.2686C5.28895 14.243 4.59056 12.9364 4.30763 11.5139C4.0247 10.0913 4.16995 8.61687 4.725 7.2769C5.28006 5.93693 6.21999 4.79164 7.42594 3.98586C8.63189 3.18008 10.0497 2.75 11.5001 2.75C12.9505 2.75 14.3683 3.18008 15.5742 3.98586C16.7802 4.79164 17.7201 5.93693 18.2752 7.2769C18.8302 8.61687 18.9755 10.0913 18.6925 11.5139C18.4096 12.9364 17.7112 14.243 16.6857 15.2686Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.30e3fe8aa9d3e9b2cb67cd01be225b3c.svg";
export { ForwardRef as ReactComponent };